import { Action } from 'redux';
import { PhoneSearchResult } from 'model/PhoneSearch';

//Action Types
export const PHONESEARCH_START_ACTION_TYPE = 'PHONESEARCH_START';
export const PHONESEARCH_SUCCESS_ACTION_TYPE = 'PHONESEARCH_SUCCESS';
export const PHONESEARCH_ERROR_ACTION_TYPE = 'PHONESEARCH_ERROR';

//Actions
type PhoneSearchStartAction = Action<typeof PHONESEARCH_START_ACTION_TYPE>;

interface PhoneSearchSuccessAction extends Action<typeof PHONESEARCH_SUCCESS_ACTION_TYPE> {
    payload: {
        results: Array<PhoneSearchResult>;
    };
}

interface PhoneSearchErrorAction extends Action<typeof PHONESEARCH_ERROR_ACTION_TYPE> {
    payload: {
        error: string;
    };
}

export type PhoneSearchAction = PhoneSearchStartAction | PhoneSearchSuccessAction | PhoneSearchErrorAction;
